var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { makeStyles, Step, StepConnector, StepLabel, Stepper } from "@material-ui/core";
import * as React from 'react';
export var CreateWorkflow = function (_a) {
    var steps = _a.steps, activeStep = _a.activeStep, rest = __rest(_a, ["steps", "activeStep"]);
    return React.createElement(Workflow, __assign({ steps: steps, activeStep: activeStep }, rest));
};
export var Workflow = function (_a) {
    var steps = _a.steps, activeStep = _a.activeStep, rest = __rest(_a, ["steps", "activeStep"]);
    var classes = useWorkflowStyles(rest);
    return steps.length ?
        React.createElement(Stepper, { classes: classes, alternativeLabel: true, activeStep: activeStep, connector: React.createElement(WorkflowConnector, { activeStep: activeStep }) }, steps.map(function (step) { return (React.createElement(Step, { key: step.title },
            React.createElement(WorkflowStepLabel, { step: step }))); }))
        : React.createElement("div", null);
};
var useWorkflowStyles = makeStyles({
    root: {
        width: '100%',
        background: 'transparent',
        padding: 0
    }
});
var WorkflowStepLabel = function (_a) {
    var step = _a.step, rest = __rest(_a, ["step"]);
    var classes = useWorkflowStepLabelStyles(rest);
    return (React.createElement(StepLabel, __assign({ StepIconComponent: step.icon || WorkflowStepDefaultIcon }, rest),
        React.createElement("span", { className: classes.title }, step.title),
        React.createElement("br", null),
        React.createElement("span", { className: classes.description }, step.description)));
};
var useWorkflowStepLabelStyles = makeStyles({
    title: {
        fontWeight: 800,
        color: function (props) { return props.active ? '#3d6889' : (props.completed ? '#57bf90' : ''); }
    },
    description: {
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: 100,
        wordWrap: 'break-word',
        marginTop: 10,
        color: function (props) { return props.active ? '#3d6889' : (props.completed ? '#57bf90' : ''); }
    }
});
var WorkflowStepDefaultIcon = function (_a) {
    var active = _a.active, completed = _a.completed, rest = __rest(_a, ["active", "completed"]);
    var classes = useWorkflowStepDefaultIconStyles(rest);
    var classNames = classes.root;
    var inactive = !active && !completed;
    if (active)
        classNames += ' ' + classes.active;
    if (completed)
        classNames += ' ' + classes.completed;
    if (inactive)
        classNames += ' ' + classes.circle;
    return (React.createElement("span", { className: classNames },
        React.createElement("span", { className: classes.text }, rest.icon)));
};
var useWorkflowStepDefaultIconStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        width: '28px',
        height: '28px',
        borderRadius: '50%',
        border: '2px solid'
    },
    active: {
        color: 'white',
        backgroundColor: '#3d6889',
        borderColor: '#3d6889'
    },
    circle: {
        color: '#bcc4c9',
        borderColor: '#bcc4c9'
    },
    completed: {
        backgroundColor: '#57bf90',
        color: 'white',
        borderColor: '#57bf90'
    },
    text: {
        width: '20px',
        paddingLeft: 4,
        fontSize: 13,
        textAlign: 'center',
        fontStyle: 'bold'
    }
});
var WorkflowConnector = function (props) {
    var classes = useWorkflowConnectorStyles(props);
    var activeStep = props.activeStep, rest = __rest(props, ["activeStep"]);
    return React.createElement(StepConnector, __assign({ classes: classes }, rest));
};
var useWorkflowConnectorStyles = makeStyles({
    alternativeLabel: {
        left: 'calc(-50% + 14px)',
        right: 'calc(50% + 14px)'
    },
    active: {
        '& $line': {
            backgroundColor: '#57bf90',
            backgroundImage: 'linear-gradient(to right, #57bf90 50%, #3d6889 50%)'
        },
    },
    completed: {
        '& $line': {
            backgroundColor: '#57bf90',
        },
    },
    line: {
        borderWidth: 0,
        height: 5,
        backgroundColor: '#bcc4c9',
        backgroundImage: function (props) { return props.activeStep + 1 === props.index ? 'linear-gradient(to right, #3d6889 50%, #bcc4c9 50%)' : ''; }
    }
});
//# sourceMappingURL=workflow.js.map